
install_formpack = (permalink) ->
  if current_user.guest()
    redirect_url = App.Helpers.URIs.parse(window.location.href)
    redirect_url.set_param("install", permalink)
    redirect_url = btoa(redirect_url.value())

    return App.hard_redirect_to Routes.user_session_path(redirect: redirect_url)

  button = document.querySelectorAll(".install_formpack_button[data-formpack='#{permalink}']")
  return if loading button[0]
  add_loader button

  modal = App.Interface.Modal.find_by_id("install_options_#{permalink}")
  modal ?= App.Interface.Modal.from_url(Routes.new_store_installation_path(permalink, modal: true))

  modal.show()
  .then -> remove_loader(button)
  .catch (error) ->
    remove_loader(button)
    throw error

  modal

$ ->
  $(".formpack_description").detect_links()

  if params("install")?
    install_formpack(params("install"))

  # Show an information notice if the user is logged out and hasn't seen it, to explain
  # what Forms is, and how formpacks can be used.
  if typeof(Storage) != "undefined"
    if localStorage.getItem("seen_sonadier_forms_info") != "true"
      localStorage.setItem("seen_sonadier_forms_info", "true")

      sonadier_forms_info = document.getElementById("sonadier_forms_info")
      sonadier_forms_info.style.display = "block" if sonadier_forms_info?

  $(document).on "click", ".store_button_inner", (event) ->
    button = event.currentTarget
    install_formpack button.dataset.formpack

  $(document).on "click", ".installed_facility_select", (event) ->
    select = $(event.currentTarget)
    wrapper = select.closest(".installed_facility_wrapper")
    bodies = wrapper.find(".installed_facility_body")
    selected_body = wrapper.find(".installed_facility_body[data-permalink='#{select.val()}']")

    bodies.hide()
    selected_body.show()

  $(document).on "click", "#open_side_column", ->
    side_column = document.querySelector(".side_column")

    # .hidden_side_column only applies display: none on smaller screens.
    # If the screen is made larger after hiding the side column, it will be visible again.
    # Using just slideToggle would hide it even after making the screen larger.
    if App.Helpers.Elements.visible(side_column)
      App.Helpers.Elements.slide_up side_column, ->
        side_column.classList.add("hidden_side_column")
        side_column.style.display = "block"
    else
      side_column.style.display = "none"
      side_column.classList.remove("hidden_side_column")

      App.Helpers.Elements.slide_down side_column
